<template>
	<b-card v-if="isOpen" class="blumar-chat" no-body>
		<div class="topbar">
			<b class="title">{{title}}</b>
			<span class="close-button material-icons" @click="close">close</span>
		</div>

		<div class="message-wrapper">
			<ul class="messages" ref="messages">
				<li v-for="(messages, i) in consecutiveUserMessages" :key="i" class="message">
					<message-group :messagesGroup="messages" :chatGroup="group" :owner="group.isOwnMessage(messages)"/>
				</li>
			</ul>
		</div>

		<div class="message-input">
			<div class="message-input-box">
				<input v-model="messageText" placeholder="Digite uma mensagem..." @keyup.enter="sendMessage"/>
				<b-spinner v-if="isSendingMessage" small/>
				<span class="material-icons pointer" @click="sendMessage">send</span>
			</div>
		</div>

	</b-card>
</template>

<script>
import { connectWebSocket } from '../../../chat-utils';
import ChatService from '../../../service/ChatService';
import moment from 'moment';
import MessageGroup from './MessageGroup.vue';

export default {
	components: { MessageGroup },
	data() {
		return {
			isOpen: false,
			messageText: undefined,
			socket: undefined,
			group: null,
			chatService: new ChatService(),
			isSendingMessage: false,
		};
	},
	computed: {
		consecutiveUserMessages() {
			return this.group.messages.reduce((messageGroups, message) => {
				let newMessageGroup = {user: message.user, messages: [message], date: moment(message.creationDate, 'DD/MM/YYYY')};

				if (messageGroups.length === 0) return [newMessageGroup];

				let lastMessageGroup = messageGroups[messageGroups.length - 1];

        let canUseLastGroup =
          lastMessageGroup.user.id === message.user.id
          && lastMessageGroup.user.userType === message.user.userType
          && lastMessageGroup.date.isSame(moment(message.creationDate, 'DD/MM/YYYY'));

				if (canUseLastGroup)
					lastMessageGroup.messages.push(message);
				else
					messageGroups.push(newMessageGroup);

				return messageGroups;
			}, []);
		},
	},
	async mounted() {
		this.socket = await connectWebSocket();
	},
	destroyed() {
		if (this.socket) this.socket.deactivate();
	},
	methods: {
		async open(group, title) {
			this.group = group;
			this.isOpen = true;
      this.title = title;

			group.onPushedMessage = this.scrollToLastMessages;
			group.onBroadcastedMessage = () => group.readUnseenMessages();

			group.readUnseenMessages();
			await group.fetchMessages();
			this.scrollToLastMessages();
		},
		close() {
			this.isOpen = false;
			if (this.group) {
				this.group.onPushedMessage = null;
				this.group.onBroadcastedMessage = null;
				this.group = null;
			}
		},
		scrollToLastMessages() {
			this.$nextTick(() => {
				this.$nextTick(() => {
					if (this.$refs.messages) this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
				});
			});
		},
		async sendMessage() {
			this.isSendingMessage = true;
			await this.group.sendMessage(this.messageText);
			this.isSendingMessage = false;
			this.messageText = '';
		},
	},
	filters: {
		time(value) {
			return moment(value, 'DD/MM/YYYY hh:mm').format('hh:mm');
		},
	},
}
</script>

<style lang="scss" scoped>
.blumar-chat {
	width: 500px;
	position: fixed;
	bottom: 0;
	right: 40px;
	height: 560px;
	display: flex;
	flex-direction: columns;
	z-index: 2;

  border-radius: 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

	ul {
		list-style-type: none;
	}

	.message-wrapper {
		flex-grow: 1;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}

	.messages {
		padding: 20px;
		margin: 0;
		overflow-y: auto;
	}

	.message:not(:first-of-type) {
		margin-top: 10px;
	}

	.message-input {
		padding: 10px;
		border-top: 1px solid rgba(0,0,0,0.125);

		.message-input-box {
			display: flex;
			align-items: center;
			width: 100%;
			padding: 5px 15px;
			border-radius: 20px;
			border: 1px solid rgba(0,0,0,0.125);
		}

		input {
			display: block;
			width: 100%;
			border: none;
			outline: none;
		}
	}

	.topbar {
		display: flex;
		justify-content: space-between;
		padding: 5px;
		border-bottom: 1px solid rgba(0,0,0,0.125);
	}

	.topbar .title {
		margin-left: 10px;
	}

	.close-button {
		display: block;
		width: fit-content;
		cursor: pointer;
	}

	.pointer {
		cursor: pointer;
		user-select: none;
	}

	@media (max-width: 750px) {
		display: flex;
		width: 85%;
		height: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/blumar-chat/BlumarChat.vue